import { render, staticRenderFns } from "./damagedItemsRail.vue?vue&type=template&id=fef641c6&"
import script from "./damagedItemsRail.vue?vue&type=script&lang=js&"
export * from "./damagedItemsRail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports